import React, { useState } from "react";

// Image with a skeleton placeholder that fades in once loaded.
// (The CDN serves only full-size originals, so a true low-res blur-up
// placeholder isn't possible — a skeleton shimmer is the honest choice.)
export default function ProgressiveImg({ src, srcSet, alt, className, onClick }) {
  const [loaded, setLoaded] = useState(false);

  return (
    <>
      {!loaded && <span className="skeleton" aria-hidden="true" />}
      <img
        src={src}
        srcSet={srcSet}
        alt={alt || ""}
        loading="lazy"
        decoding="async"
        onLoad={() => setLoaded(true)}
        onClick={onClick}
        className={`${className || ""} progressive-img ${
          loaded ? "is-loaded" : "is-loading"
        }`}
      />
    </>
  );
}
